import React from 'react'
import RoleManagement from './RoleManagement'
import AdminAddJob from './AdminAddJob'
import AdminUpdateJob from './AdminUpdateJob'
import AdminDeleteJob from './AdminDeleteJob'

function AdminPanelContent(activeItem : any) {
  if(activeItem ==='admin')
    return (
      <RoleManagement />
    )
  if(activeItem ==='add')
    return (
    <AdminAddJob />
  )
  if(activeItem ==='update')
    return (
      <AdminUpdateJob />

    )
  if(activeItem ==='delete')
    return (
      <AdminDeleteJob />
  )
}

export default AdminPanelContent